import { render, staticRenderFns } from "./purchase_detail.vue?vue&type=template&id=45c0348a&"
import script from "./purchase_detail.vue?vue&type=script&lang=js&"
export * from "./purchase_detail.vue?vue&type=script&lang=js&"
import style0 from "./purchase_detail.vue?vue&type=style&index=0&id=45c0348a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports